import { Component, OnInit } from '@angular/core';
import { Correspondant } from './../../../../domaine/correspondant';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorrespondantService } from './../../../../service/correspondant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SocieteService } from './../../../../../utilisateur/service/societe.service';
import { PersonneService } from './../../../../service/personne.service';
import { forkJoin } from 'rxjs';
import { Societe } from './../../../../../utilisateur/domaine/societe';
import { Personne } from './../../../../domaine/personne';
import { CompagnieService } from './../../../../service/compagnie.service';
import { Compagnie } from './../../../../domaine/compagnie';

@Component({
  selector: 'app-edit-correspondant',
  templateUrl: './edit-correspondant.component.html',
  styleUrls: ['./edit-correspondant.component.scss']
})
export class EditCorrespondantComponent implements OnInit {

  correspondantEdit: Correspondant;
  compagnies: Compagnie[];
  personnes: Personne[];

  correspondantForm: FormGroup;

  categories: any[] = [{name: 'Oui'}, {name: 'Non'}];

  constructor(
    private correspondantService: CorrespondantService,
    private personneService: PersonneService,
    private compagnieService: CompagnieService,
    private route: ActivatedRoute ,
    private router: Router) {   
                
                
    this.correspondantEdit = new Correspondant();
    const slug = this.route.snapshot.paramMap.get('slug');  
    
    const compagnies = this.compagnieService.all();
    const personnes = this.personneService.all();
    const correspondant = this.correspondantService.find(slug);

    this.correspondantForm = new FormGroup({
      civilite : new FormControl(null, Validators.required),
      nom : new FormControl(null, Validators.required),
      prenom : new FormControl(null, Validators.required),
      compagnie : new FormControl(null, Validators.required),
      email : new FormControl(null),
      telephone : new FormControl(null),
      actif : new FormControl({name:'Non'} , Validators.required )
    });

    forkJoin([ compagnies, personnes , correspondant ]).subscribe(
      result => {        
        this.compagnies = result[0];
        this.personnes = result[1];
        this.correspondantEdit = result[2];
        this.correspondantForm.setValue({
          civilite : this.correspondantEdit.civilite,
          nom : this.correspondantEdit.nom,
          prenom : this.correspondantEdit.prenom,
          compagnie : this.correspondantEdit.compagnie,        
          email : this.correspondantEdit.email,
          telephone : this.correspondantEdit.telephone,
          actif :   {name:(this.correspondantEdit.actif)? 'Oui': 'Non'}
        });

      }
    );
   

  }

  ngOnInit(): void {
    
  }

  update(){
    this.correspondantEdit.civilite = this.correspondantForm.get('civilite').value;
    this.correspondantEdit.nom = this.correspondantForm.get('nom').value;
    this.correspondantEdit.prenom = this.correspondantForm.get('prenom').value;    
    this.correspondantEdit.email = this.correspondantForm.get('email').value;
    this.correspondantEdit.telephone = this.correspondantForm.get('telephone').value;
    this.correspondantEdit.compagnie = this.correspondantForm.get('compagnie').value;
    this.correspondantEdit.actif = (this.correspondantForm.get('actif').value.name == 'Oui')? true: false;   
    this.correspondantService.update(this.correspondantEdit , this.correspondantEdit.slug).subscribe(
      data => {
        this.router.navigate(['/numerotation/administration/correspondant']);
      },
      err => {
        alert(err.error.message);
      }
    );
  }

  delete(){
    this.correspondantService.delete(this.correspondantEdit.slug).subscribe(
      data => {
        this.router.navigate(['/numerotation/administration/correspondant']);
      },
      err => {
        alert(err.error.Message);
      }
    );
  }


}
